import { render, staticRenderFns } from "./OneProductTileRightActions.vue?vue&type=template&id=33635078&scoped=true&"
import script from "./OneProductTileRightActions.vue?vue&type=script&lang=ts&"
export * from "./OneProductTileRightActions.vue?vue&type=script&lang=ts&"
import style0 from "./OneProductTileRightActions.vue?vue&type=style&index=0&id=33635078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_css-loader@4.3.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33635078",
  null
  
)

export default component.exports